/**
 * @file: withStoreFeature.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { WrappedNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { StoreFeature } from '@euler/model/enum';
import { memo } from 'react';
import { StoreFeatureGate } from './StoreFeatureGate';

/**
 * A navigator screen of one feature. The route stays registered, so a deep
 * link to it lands on the "not enabled" view instead of nowhere.
 */
export function withStoreFeature<T extends Record<string, any>>(
  screen: WrappedNavigatorScreen<T>,
  feature: StoreFeature,
): WrappedNavigatorScreen<T> {
  const Screen = screen;
  const Gated = memo((props: T) => (
    <StoreFeatureGate feature={feature}>
      <Screen {...props} />
    </StoreFeatureGate>
  )) as unknown as WrappedNavigatorScreen<T>;
  Gated.component = screen.component;
  Gated.options = screen.options;
  Gated.extraProps = screen.extraProps;
  return Gated;
}
